import { Link as RouterLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Tag } from "@carbon/react";
import { ActionItem, Urgency } from "../../../types";
import { actionCopy, routeFor } from "./actionCopy";

interface Props {
  item: ActionItem;
}

const urgencyClass: Record<Urgency, string> = {
  [Urgency.HIGH]: "manager-dashboard__bar manager-dashboard__bar--high",
  [Urgency.MEDIUM]: "manager-dashboard__bar manager-dashboard__bar--medium",
  [Urgency.LOW]: "manager-dashboard__bar manager-dashboard__bar--low",
};

/**
 * One row, shared by both action bands. The only difference between a "my work"
 * row and a "team" row is whether assignee is populated.
 */
const ActionRow = ({ item }: Props) => {
  const { t } = useTranslation();
  const copy = actionCopy[item.type];

  const age =
    item.dueAt !== null
      ? new Date(item.dueAt).toLocaleDateString()
      : t("managerDashboard.ageDays", { count: item.ageDays });

  return (
    <RouterLink className="manager-dashboard__row" to={routeFor(item)}>
      <span className={urgencyClass[item.urgency]} aria-hidden="true" />
      <span className="manager-dashboard__main">
        <span className="manager-dashboard__row-title">
          {item.reference} · {item.subject}
        </span>
        <span className="manager-dashboard__meta">
          {t(copy.metaKey, { count: item.offerCount ?? 0 })}
        </span>
      </span>
      {item.assignee ? <Tag type="gray">{item.assignee}</Tag> : null}
      <span className="manager-dashboard__age">{age}</span>
      <span className="manager-dashboard__cta">{t(copy.ctaKey)}</span>
    </RouterLink>
  );
};

export default ActionRow;
